import { useBreadcrumb } from "core/features/breadcrumbs";
import GrupoUnidades from "./components/GrupoUnidades/GrupoUnidades";
import Container from "components/Container";

function UnidadeListagemPage() {
  useBreadcrumb([{ name: "Cadastros" }, { name: "Grupos de Unidades" }]);

  return (
    <Container>
      <GrupoUnidades />
    </Container>
  );
}

export default UnidadeListagemPage;
